import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { Approach } from "../components/site/Approach";
import { Therapies } from "../components/site/Therapies";
import { Process } from "../components/site/Process";
import { Practicalities } from "../components/site/Practicalities";
import { WhoIWorkWith } from "../components/site/WhoIWorkWith";
import { Testimonials } from "../components/site/Testimonials";
import { Crisis } from "../components/site/Crisis";
import { ContactCTA } from "../components/site/ContactCTA";
import { Footer } from "../components/site/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-[#FDFBF7] text-[#1A1C1A]">
      <Navbar />
      <main>
        <Hero />
        <Approach />
        <Therapies />
        <Process />
        <Practicalities />
        <WhoIWorkWith />
        <Testimonials />
        <Crisis />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
}
